import React from 'react'
import { client } from '../../utils'
import PropTypes from 'prop-types'
import Assessment from './Assessment'
import {
  SortableContainer,
  SortableElement,
  arrayMove,
} from 'react-sortable-hoc'
import EditGroupModal from './EditGroupModal'
import { useStateValue } from '../state'
import { canvasSupportDashboard as endpoints } from '../../api_urls'

const Group = props => {
  const [currentState, dispatch] = useStateValue()

  let changeGroupOrder = e => {
    const group = currentState.nestedGroupData.find(
      group => group[0] === props.groupId
    )
    let newIndex = e.target.value - 1
    let newOrder = currentState.nestedGroupData.filter(
      group => group[0] !== props.groupId
    )
    newOrder.splice(newIndex, 0, group)
    for (let i = 0; i < newOrder.length; i++) {
      newOrder[i][1] = i + 1
    }
    dispatch({ type: 'UPDATE_NESTED_GROUPS', payload: newOrder })
  }

  let [modalOpen, setModalOpen] = React.useState(false)
  let openCloseModal = () => {
    setModalOpen(!modalOpen)
  }

  let handleGroupNameInput = e => {
    dispatch({
      type: 'UPDATE_GROUP_NAME',
      groupId: props.groupId,
      groupName: e.target.value,
    })
  }

  let handleWeightInput = e => {
    dispatch({
      type: 'UPDATE_GROUP_WEIGHT',
      groupId: props.groupId,
      groupWeight: e.target.value,
    })
  }

  const editGroup = async () => {
    dispatch({ type: 'UPDATE_LOADING_STATUS', loading: true })
    const url = endpoints.editGroup()
    let currGroup = currentState.groups.find(
      group => group.id === props.groupId
    )
    let data = { name: currGroup.name, groupId: props.groupId }
    if (props.applyGroupWeights) {
      data['group_weight'] = currGroup.group_weight
    }
    let resp = await client.post(url, data)
    console.log(resp.data)
    dispatch({ type: 'UPDATE_GROUPS', payload: resp.data.groups })
    openCloseModal()
    dispatch({ type: 'UPDATE_LOADING_STATUS', loading: false })
  }

  let onSortEnd = ({ oldIndex, newIndex }) => {
    let groupActs = currentState.groups.find(
      group => group.id === props.groupId
    ).acts
    let acts = arrayMove(groupActs, oldIndex, newIndex)
    dispatch({ type: 'UPDATE_GROUP_ACT_ORDER', groupId: props.groupId, acts })
  }

  const SortableAssessment = SortableElement(({ act }) => {
    return (
      <Assessment
        title={act.name}
        key={act.id}
        createdAt={act.created_at}
        id={act.id}
        dueAt={act.due_at}
        lockAt={act.lock_at}
        pointsPossible={act.points_possible}
        published={act.published === 'true'}
        unlockAt={act.unlock_at}
        subTypes={act.submission_types}
        workflowState={act.workflow_state}
        groupId={props.groupId}
      />
    )
  })

  const SortableList = SortableContainer(({ groupActs }) => {
    let acts = []
    for (let i = 0; i < groupActs.length; i++) {
      acts.push(currentState.acts.find(act => act.id === groupActs[i][0]))
    }
    return (
      <div>
        {acts.map((act, index) => {
          return <SortableAssessment key={act.id} index={index} act={act} />
        })}
      </div>
    )
  })

  return (
    <div className="card-myed">
      <div className="d-flex justify-content-between">
        <div className="d-flex justify-content-start">
          <select
            className="mr-3"
            value={props.position}
            onChange={changeGroupOrder}
          >
            {currentState.nestedGroupData.map((group, index) => {
              return (
                <option value={group[1]} key={index}>
                  {group[1]}
                </option>
              )
            })}
          </select>
          <h3>
            {currentState.groups.find(group => group.id === props.groupId).name}
          </h3>
          <button
            className="btn btn-myed btn-default btn-default-myed btn-sm-myed ml-5"
            onClick={openCloseModal}
          >
            Edit
          </button>
        </div>
        {props.applyGroupWeights ? (
          <p>
            Group Weight:{' '}
            {
              currentState.groups.find(group => group.id === props.groupId)
                .group_weight
            }
            %
          </p>
        ) : null}
      </div>
      {currentState.groups.find(group => group.id === props.groupId).acts[0] ? (
        <SortableList
          groupActs={
            currentState.groups.find(group => group.id === props.groupId).acts
          }
          onSortEnd={onSortEnd}
          helperClass="DragHelper"
        />
      ) : (
        <div>No assignments in this group</div>
      )}
      <EditGroupModal
        modalOpen={modalOpen}
        openCloseModal={openCloseModal}
        groupName={
          currentState.groups.find(group => group.id === props.groupId).name
        }
        handleGroupNameInput={handleGroupNameInput}
        applyGroupWeights={props.applyGroupWeights}
        handleWeightInput={handleWeightInput}
        weight={Number(
          currentState.groups.find(group => group.id === props.groupId)
            .group_weight
        )}
        editGroup={editGroup}
      />
    </div>
  )
}

export default Group

Group.propTypes = {
  position: PropTypes.number,
  applyGroupWeights: PropTypes.bool,
  groupWeight: PropTypes.number,
  groupId: PropTypes.number,
}
